import {IssuePersonalData} from "../domain/entities/issue-personal-data.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * `mainEntityClass`/`mainEntityUid` (constructor args, set by whoever builds
 * this command) MUST point at this IssuePersonalData row itself, NOT at the
 * referenced Issue — see the backend entity's own doc comment on the generic
 * per-command audit-log row: pointing at the Issue would surface "User X:
 * create.issue-personal-data" in the Issue's own (tenant-wide visible) audit
 * history, defeating the privacy this feature is for.
 */
export class CreateIssuePersonalDataCommand extends AbstractCommand<IssuePersonalData> {

    name = CommandName.CREATE_ISSUE_PERSONAL_DATA;

    tags = ['entity', 'create', 'issue-personal-data'];

}
